import React, { useEffect, PropsWithChildren } from 'react';// import { logger } from "../../utils/logger";
/**
 * AntiDownloadProvider
 *
 * Globally reduces casual image downloads by disabling context menus and image dragging.
 * This does not prevent screenshots or advanced scraping.
 */
const AntiDownloadProvider: React.FC<PropsWithChildren> = ({ children }) => {
  useEffect(() => {
    const preventIfImage = (e: Event) => {
      const target = e.target as HTMLElement | null;
      if (!target) return;
      // Block right-click and long-press context menu on images
      if (target.tagName === 'IMG' || target.closest('img')) {
        e.preventDefault();
      }
    };

    const preventDragIfImage = (e: DragEvent) => {
      const target = e.target;
      // Ensure target is a valid DOM element with the closest method
      if (!target || typeof target !== 'object' || !('closest' in target) || !('tagName' in target)) {
        return;
      }
      
      const element = target as HTMLElement;
      if (element.tagName === 'IMG' || element.closest('img')) {
        e.preventDefault();
      }
    };

    // Capture phase to intercept before browser shows menu
    document.addEventListener('contextmenu', preventIfImage, true);
    document.addEventListener('dragstart', preventDragIfImage, true);

    // Global CSS tweaks for images
    const style = document.createElement('style');
    style.setAttribute('data-antidownload', 'true');
    style.textContent = `
      img { -webkit-user-drag: none; user-select: none; -webkit-touch-callout: none; }
    `;
    document.head.appendChild(style);

    return () => {
      document.removeEventListener('contextmenu', preventIfImage, true);
      document.removeEventListener('dragstart', preventDragIfImage, true);
      style.remove();
    };
  }, []);

  return <>{children}</>;
};

export default AntiDownloadProvider;


